import * as PropTypes from "prop-types";
import React, {Component} from "react";
import {Image} from "react-bootstrap";
import DetailsColumn from "./DetailsColumn";

class HonoursAndAchievements extends DetailsColumn {
    renderBody = () => {
        const {achievements} = this.props;

        return (
            <div className="honours-and-achievements-body">
                {achievements.map((achievement, index) => <HonoursAndAchievements.Cup key={index} image={achievement.image} count={achievement.count}/>)}
            </div>
        );
    };

    static defaultProps = {
        headerTitle: "Honours And Achievements"
    };

    static propTypes = {
        achievements: PropTypes.array.isRequired,
    };

    getComponentClassName = () => 'honours-and-achievements';
}

export class HonoursAndAchievementsCup extends Component {
    render = () => {
        return (
            <div className="cup-container">
                {this.renderBadge()}
                {this.renderCup()}
            </div>
        );
    };

    renderCup = () => {
        const {image} = this.props;

        return (
            <Image src={image} className="cup"/>
        );
    };

    renderBadge = () => {
        let {count} = this.props;
        if (count && count > 0) {
            if (count > 99)
                count = "+99";

            return (
                <a className="badge">
                    <small>{count}</small>
                </a>
            );
        }
    };
}

HonoursAndAchievements.Cup = HonoursAndAchievementsCup;
export default HonoursAndAchievements;
